import React, {Component} from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

import markerIcon from '../assets/images/map-marker.svg';

class Map extends Component {

  render() {

    const location = {lat: parseFloat(this.props.lat), lng: parseFloat(this.props.lng)};

    const styles = [
      {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'saturation': 36,
          },
          {
            'color': '#000000',
          },
          {
            'lightness': 40,
          },
        ],
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'visibility': 'on',
          },
          {
            'color': '#ffffff',
          },
          {
            'lightness': 10,
          },
        ],
      },
      {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 20,
          },
        ],
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'lightness': 17,
          },
          {
            'weight': 1.2,
          },
        ],
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#F2F2F2',
          },
          {
            'lightness': 20,
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#F2F2F2',
          },
          {
            'lightness': 21,
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'lightness': 17,
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'lightness': 29,
          },
          {
            'weight': 0.2,
          },
        ],
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#FFFFFF',
          },
          {
            'lightness': 18,
          },
        ],
      },
      {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'lightness': 16,
          },
        ],
      },
      {
        'featureType': 'transit',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff',
          },
          {
            'lightness': 19,
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#4D5A75',
          },
          {
            'lightness': 17,
          },
        ],
      },
    ];

    const MapWithAMarker = withScriptjs(withGoogleMap(props =>
      <GoogleMap
        defaultZoom={this.props.zoom}
        defaultCenter={location}
        options={{
          mapTypeControl: false,
          fullscreenControl: false,
          rotateControl: false,
          clickableIcons: true,
          scrollwheel: false,
          streetViewControl: false,
          styles: styles,
        }}
      >
        <Marker
          position={location}
          icon={{url: markerIcon, size: {width: 50, height: 70}, anchor: {x: 12, y: 17}, scaledSize: {width: 25, height: 35}}}
        />
      </GoogleMap>,
    ));

    return (
      <div className="map__container">
        <MapWithAMarker
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDHWepFhTvVdCoMrZ7E5s8FFknVSITdWEw&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{height: `100%`}}/>}
          containerElement={<div style={{height: `100%`}}/>}
          mapElement={<div style={{height: `100%`}} className={'map__map'}/>}
        />
      </div>
    );
  }
}

Map.defaultProps = {
  lat: '-26.678261177011763',
  lng: '153.1178599975582',
  zoom: 17,
};

export default Map;